export const HOTSPOT_SIZE_PX = 40;
export const HOTSPOT_ANIMATION_DURATION_MS = 3000;
